import React from 'react';
import './body.component.scss';

interface IProps {
    component: any;
}

class BodyComponent extends React.Component<IProps> {
    // eslint-disable-next-line
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            // main app body
            <main id="main" className="m-body">
                {this.props.component}
            </main>
        );
    }
}

export default BodyComponent;
